module.exports = __webpack_public_path__ + "static/media/slider-symbol.fcc9c272.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/slider-symbol.png
// module id = 203
// module chunks = 0